// ClientDrawer's reads (finance-real, the user 2026-10-23: "the client drawer opens and shows all the invoices open and
// sent, the most recent at the top"): the client's jobs for its name, its own flag and its done and active jobs (answer c:
// listed above its invoices, and what New invoice bills), its Clients row for the strip's figures, and its invoices (the ones
// the Invoices tab and the invoice drawer show, every status, drafts first, then the newest sent: the server's order).
import type { UseQueryResult } from "@tanstack/react-query";
import { useJobClient } from "../../hooks/useAgencyTabs";
import { useClientJobs, useJobInvoices } from "../../hooks/useLineJobs";
import { toBill } from "../../clientPage/JobInvoiceDrawers";
import type { ClientJobInvoicesResponse, ClientJobsResponse, JobClientRow, LineJob } from "../../types";

export interface ClientDrawerModel {
  invoicesQuery: UseQueryResult<ClientJobInvoicesResponse>;
  /** The client's jobs read, as its page reads it: its name, whether it is the agency's own, today and its jobs. */
  jobsQuery: UseQueryResult<ClientJobsResponse>;
  /** Its Clients row on jobs: the strip reads the same figures. */
  rowQuery: UseQueryResult<JobClientRow | null>;
  /** Done and active jobs, on no invoice yet (toBill): the drawer's jobs to bill, and what New invoice can bill. */
  billable: LineJob[];
}

export function useClientDrawer(clientId: string): ClientDrawerModel {
  const jobsQuery = useClientJobs(clientId);
  return {
    invoicesQuery: useJobInvoices(clientId),
    jobsQuery,
    rowQuery: useJobClient(clientId),
    billable: (jobsQuery.data?.jobs ?? []).filter(toBill),
  };
}
